function getColorStyle(level_type, unit_id) {

  // haplo, diet, skin, sportsは特殊ケース sports（550）は後で追加
  if ([521, 550, 569, 947, 948, 949].indexOf(unit_id) < 0) {

    switch (level_type) {
      case 1:
        return "color_low";
      case 2:
        return "color_low_mid";
      case 3:
        return "color_mid";
      case 4:
        return "color_high_mid";
      case 5:
        return "color_high";
      default:
        return "";
    }
  }
}

function haploGroup(group) {
  
    let url = "https://s3-ap-northeast-1.amazonaws.com/genesis2/images/detail/haplomap/"

    switch (group) {
      case "A":
        return url + "a.png"
      case "B":
        return url + "b.png"
      case "D":
        return url + "d.png"
      case "F":
        return url + "f.png"
      case "G":
        return url + "g.png"
      case "M7":
        return url + "m7.png"
      case "M8":
        return url + "m8.png"
      case "M9":
        return url + "m9.png"
      case "N9":
        return url + "n9.png"
      default:
        return url + "other.png"
    }
}

function findIt(array, key, value) {
  return array.filter(json => {
    if (json[key] === value) return true;
    return false;
  })
}

function roundFloat( number, n ) {
  var _pow = Math.pow( 10 , n );
  return Math.round( number * _pow ) / _pow;
}

function timeoutRedirect() {
  window.alert('<セッションタイムアウト>\n\n最後のログインからしばらく時間が経過したため、ログイン状態が解除されました。\n再度ログインをお願いします。');
  window.location.href = "https://genelife.jp/auth/login";
}

function getTagManagerArgs(vPath) {
  return {
    gtmId: 'GTM-NDN22K',
    dataLayer: {
      trackPageview: vPath,
      event: 'loadready',
    },
    dataLayerName: 'dataLayer'
  }
}

const getDhcNo = (subtypes) => {
  // TODO 複数アフィリエイト対応する際には気をつけて
  return subtypes[0].dhc_no;
}

const classifyType = (level_ids, data) => {
  return level_ids.some(level_id => level_id  === data.level_id)
}
export {
  getColorStyle,
  findIt,
  timeoutRedirect,
  roundFloat,
  haploGroup,
  getTagManagerArgs,
  getDhcNo,
  classifyType,
};


// WEBPACK FOOTER //
// ./src/components/Util.js